import useStyles from './MultipleSuggestedInput.styles';

interface OptionTextProps {
  inputValue: string;
  option: string;
}

export const OptionText = ({ inputValue, option }: OptionTextProps) => {
  const { classes } = useStyles();

  const index = option.toLowerCase().indexOf(inputValue.toLowerCase());

  if (!inputValue || option === inputValue || index === -1) {
    return <div>{option}</div>;
  }

  const before = option.substring(0, index);
  const match = option.substring(index, index + inputValue.length);
  const after = option.substring(index + inputValue.length);

  return (
    <div>
      {!!index && <span className={classes.normalText}>{before}</span>}
      <span className={classes.highlightedText}>{match}</span>
      <span className={classes.normalText}>{after}</span>
    </div>
  );
};
